import { getWrapperWeb } from "../utils/Wrapper";

export const getAllOffers = async () => {
  let url = `/offer/get-offer`;
  return getWrapperWeb(url);
};

export const getOfferById = async (id) => {
  let url = `/offer/get-offer-by-id?id=${id}`;
  return getWrapperWeb(url);
};
export const getAllOffersCustomized = async (page = 0, size = 10, sortBy, order, searchQuery) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);
  if (sortBy) params.append("sortBy", sortBy);
  if (order) params.append("order", order);
  if (searchQuery) params.append("searchQuery", searchQuery);
  
  const url = `/offer/get-offer-customized?${params.toString()}`;
  return getWrapperWeb(url);
};


// export const getOfferById = async (id) => {
//   try {
//     const response = await axiosInstance.get(`/offer/get-offer-by-id?id=${id}`);
//     return {
//       ...response.data,
//       result: {
//         ...response.data.result.result,
//         bankType: response.data.result.bankType,
//         bankName: response.data.result.bankName
//       }
//     };
//   } catch (error) {
//     throw error;
//   }
// };
